<template>
  <div>
    <h3 :id="field.id">{{ field.label[currentLanguage] }}</h3>
    <p class="small" v-if="field.description[currentLanguage]" v-html="field.description[currentLanguage]"></p>
  </div>
</template>

<script>
export default {
  props: ['value', 'field', 'currentLanguage', 'disabledStatus']
}
</script>



// WEBPACK FOOTER //
// src/components/elements/description.vue